import React, { PureComponent } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { styles, translations } from 'gipsy-misc'
import { Checkbox } from 'gipsy-ui'

const propTypes = {
  email: PropTypes.string.isRequired,
  calendar: PropTypes.object.isRequired,
  onToggleSelect: PropTypes.func.isRequired
}

export class CalendarLine extends PureComponent {
  onChange = () => {
    const { email, calendar } = this.props
    this.props.onToggleSelect(email, calendar)
  }

  render() {
    const { calendar } = this.props
    let name = calendar.nameOverride || calendar.name
    if (calendar.isPrimary) {
      name += ` - ${translations.settings.section.account.calendars.primary}`
    }
    return (
      <CalendarLineContainer>
        <Checkbox paramName="isSelected" checked={!!calendar.isSelected} onChange={this.onChange} size={24} />
        <Name>{name}</Name>
      </CalendarLineContainer>
    )
  }
}

const CalendarLineContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
`
const Name = styled.div`
  font: ${styles.fonts.primaryFont};
  font-size: ${styles.fonts.fontSizeSmall};
  margin-left: 10px;
`
CalendarLine.propTypes = propTypes

export default CalendarLine



// WEBPACK FOOTER //
// ./src/pages/settings/components/emailaccounts/calendarline.js